import { Injectable } from '@angular/core';
import { DealerParkingDetails, DealerParkingImageModel } from '../business-entities/dealer-parking-model';
import { GenericResponse } from '../business-entities/generic-response';
import { DealerParkingDataService } from '../data-services/dealer-parking-data.service';


@Injectable({
  providedIn: 'root'
})

export class DealerParkingBusinessService {
  isDealerLoggedIn: boolean;
  constructor(private service: DealerParkingDataService) {
  }
  dealerParkingDetails: DealerParkingDetails;
  async getDealerParkingImage(DealerId: string): Promise<DealerParkingDetails> {
    await this.service
      .getDealerParkingImage(DealerId)
      .then(
        (res: GenericResponse<DealerParkingDetails>) => {
          this.dealerParkingDetails = res.responseObject;
        }
      );
    return this.dealerParkingDetails;
  }

  addDealerparkingImage(model: DealerParkingImageModel): Promise<any> {
    return this.service.addDealerparkingImage(model);
  }
}
